import { useState, useEffect } from "react";
import { AiOutlineClose } from "react-icons/ai";

const ProductEditFormStep1 = ({ formik }) => {
    const [isDragging, setIsDragging] = useState(false);

    const handleImageChange = (file) => {
        if (!file) return;

        if (formik.values.imageFile && formik.values.imagePreview) {
            URL.revokeObjectURL(formik.values.imagePreview);
        }

        formik.setFieldValue("imageFile", file);
        const previewUrl = URL.createObjectURL(file);
        formik.setFieldValue("imagePreview", previewUrl);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        const file = e.dataTransfer.files?.[0];
        handleImageChange(file);
    };

    useEffect(() => {
        return () => {
            if (formik.values.imageFile && formik.values.imagePreview) {
                URL.revokeObjectURL(formik.values.imagePreview);
            }
        };
    }, [formik.values.imageFile, formik.values.imagePreview]);


    return (
        <div className="space-y-6 max-w-xl mx-auto">
            <div>
                <p className="font-medium mb-2">Imagem do Produto</p>
                <div
                    className={`flex items-center justify-center border-2 border-dashed rounded-lg p-6 transition
          ${isDragging ? "border-blue-600 ring-2 ring-blue-200" : "border-gray-300"}`}
                    onDragOver={(e) => {
                        e.preventDefault();
                        setIsDragging(true);
                    }}
                    onDragLeave={() => setIsDragging(false)}
                    onDrop={handleDrop}
                >
                    {formik.values.imagePreview ? (
                        <div className="relative w-56 h-56 flex-shrink-0">
                            <img
                                src={formik.values.imagePreview}
                                alt="Preview"
                                className="w-full h-full object-cover rounded-xl"
                            />
                            <button
                                type="button"
                                className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1"
                                onClick={() => {
                                    formik.setFieldValue("imageFile", null);
                                    formik.setFieldValue("imagePreview", null);
                                }}
                            >
                                <AiOutlineClose size={14} />
                            </button>
                        </div>
                    ) : (
                        <label className="cursor-pointer text-sm text-gray-500 text-center">
                            <input
                                type="file"
                                accept="image/*"
                                className="hidden"
                                onChange={(e) => handleImageChange(e.target.files?.[0])}
                            />
                            Clique ou arraste a imagem aqui
                        </label>
                    )}
                </div>
            </div>

            <label>
                Nome do Produto
                <input
                    name="name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`w-full px-3 py-2 border rounded
            ${formik.touched.name && formik.errors.name ? "border-red-500" : "border-gray-300"}`}
                />
                {formik.touched.name && formik.errors.name && (
                    <p className="text-red-500 text-xs">{formik.errors.name}</p>
                )}
            </label>

            <div className="grid grid-cols-2 gap-x-4 my-4">
                <label>
                    Código de Barras
                    <input
                        name="barcode"
                        value={formik.values.barcode}
                        onChange={formik.handleChange}
                        className="w-full px-3 py-2 border rounded border-gray-300"
                    />
                </label>
                <label>
                    Marca
                    <input
                        name="brand"
                        value={formik.values.brand}
                        onChange={formik.handleChange}
                        className="w-full px-3 py-2 border rounded border-gray-300"
                    />
                </label>
            </div>


            <div className="grid lg:grid-cols-2 gap-x-4 my-4">
                <label>
                    Preço (R$)
                    <input
                        name="price"
                        type="number"
                        step="0.01"
                        value={formik.values.price}
                        onChange={formik.handleChange}
                        className="w-full px-3 py-2 border rounded border-gray-300"
                    />
                </label>
                <label>
                    Preço Online (R$)
                    <input
                        name="online_price"
                        type="number"
                        step="0.01"
                        value={formik.values.online_price}
                        onChange={formik.handleChange}
                        className="w-full px-3 py-2 border rounded border-gray-300"
                    />
                    <p className="text-xs text-gray-400 mt-1">Opcional. Se diferente do preço padrão, usado nas compras online pelo responsável.</p>
                </label>
            </div>

            <div className="grid lg:grid-cols-2 gap-x-4 my-4">
                <label> Data de Fabricação:
                    <input className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.fabrication_date && formik.errors.fabrication_date ? 'border-red-500' : ''}`}
                        name="fabrication_date"
                        type="date"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.fabrication_date} />

                    {formik.touched.price && formik.errors.price && (<p className="text-red-500 text-xs font-medium absolute">{formik.errors.fabrication_date}</p>)}
                </label>

                <label> Data de Validade:
                    <input className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.expiration_date && formik.errors.expiration_date ? 'border-red-500' : ''}`}
                        name="expiration_date"
                        type="date"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.expiration_date} />

                    {formik.touched.expiration_date && formik.errors.expiration_date && (<p className="text-red-500 text-xs font-medium absolute">{formik.errors.expiration_date}</p>)}
                </label>
            </div>
        </div>
    );
};

export default ProductEditFormStep1;
